import { useEffect, useState } from "react";
import axios from "axios";
import { X, AlertTriangle, CheckCircle2, Info, AlertOctagon } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const STYLES = {
  success: { cls: "bg-green-50 border-green-200 text-green-800", Icon: CheckCircle2 },
  info: { cls: "bg-blue-50 border-blue-200 text-blue-800", Icon: Info },
  warning: { cls: "bg-yellow-50 border-yellow-200 text-yellow-800", Icon: AlertTriangle },
  error: { cls: "bg-red-50 border-red-200 text-red-800", Icon: AlertOctagon },
};

export const NotificationsBar = () => {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [dismissed, setDismissed] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem("vt_dismissed_notifs") || "[]"); } catch { return []; }
  });

  useEffect(() => {
    if (!user) { setItems([]); return; }
    axios.get(`${API}/notifications`).then((r) => setItems(r.data || [])).catch(() => {});
  }, [user]);

  const dismiss = (id) => {
    const next = [...dismissed, id];
    setDismissed(next);
    sessionStorage.setItem("vt_dismissed_notifs", JSON.stringify(next));
  };

  const visible = items.filter((n) => !dismissed.includes(n.id));
  if (!visible.length) return null;

  return (
    <div data-testid="notifications-bar" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-4 space-y-2">
      {visible.map((n) => {
        const { cls, Icon } = STYLES[n.type] || STYLES.info;
        return (
          <div key={n.id} data-testid={`notification-${n.id}`} className={`flex items-center gap-3 border rounded-xl px-4 py-3 text-sm font-medium ${cls}`}>
            <Icon className="w-5 h-5 flex-shrink-0" />
            <span className="flex-1">{n.message}</span>
            {n.link && (
              <a href={n.link} data-testid={`notification-link-${n.id}`} className="underline font-bold whitespace-nowrap hover:opacity-80">
                Ir ahora
              </a>
            )}
            <button data-testid={`notification-dismiss-${n.id}`} onClick={() => dismiss(n.id)} className="p-1 rounded-full hover:bg-black/5" aria-label="Cerrar aviso">
              <X className="w-4 h-4" />
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default NotificationsBar;
